import { CachedRequest } from './base/cachedRequest'
import { endpoint } from './endpoints/def'

export const instance = new CachedRequest(1000 * 60)

export async function apiGetLatestTerms(lang: string) {
  return instance.get(`${endpoint.getLatestTerms}/${lang}`, lang)
}